import * as React from 'react';
import { useEffect, useState } from 'react';
import './SelectAddonService.scss';
import Utils from '@/utils/util';
import { AppointmentData, CalendarUsers, Service } from '../types';
import { UseServiceOptions, useGetService } from '../api/getServices';
import { UserContext } from '@/components/Layout';
import { BackNav } from '@/components/BackNavigation/BackNavigation';
import { useTranslation } from 'react-i18next';
import { businessCurrency } from '@/features/Language/api/getCountryCurrency';

type SelectAddonProps = {
  onChange: (appointmentData: AppointmentData) => void;
  onNext?: () => void;
  onBackClick?: () => void;
  appointmentData?: AppointmentData;
  business?: CalendarUsers;
};

export const SelectAddonServices = ({
  business,
  appointmentData,
  onNext,
  onBackClick,
  onChange,
}: SelectAddonProps) => {
  const getServicesMutation = useGetService();

  const userContext = React.useContext(UserContext);
  const [showPriceBreakup, setShowPriceBreakup] = useState<boolean>(false);
  const [addonServices, setAddonServices] = useState<Service[]>();
  const [searchString, setSearchString] = useState<string>();

  const { t } = useTranslation();


  useEffect(() => {
    fetchService();
  }, []);

  const fetchService = async () => {
    const businessId = business?.id ? parseInt(business?.id) : undefined;
    const req: UseServiceOptions = {
      businessId: businessId,
      addons: true,
      active: true,
    };
    const res = await getServicesMutation.mutateAsync(req);
    res.list.forEach((service) => {
      const filteredAddonsService =
        appointmentData?.selectedAddons &&
        appointmentData?.selectedAddons.find((sa) => sa.id === service.id);
      if (filteredAddonsService) {
        service.selected = true;
      }
    });
    setAddonServices(res.list);
  };
  const selectAddons = (e: any, service: Service) => {
    e.preventDefault();
    service.selected = service.selected ? false : true;
    const selected = addonServices?.filter((as) => as.selected);
    addonServices && setAddonServices([...addonServices]);
    if (appointmentData) {
      appointmentData.selectedAddons = selected;
      onChange({ ...appointmentData });
    }
  };

  let price: number = Utils.getPriceFromService(appointmentData?.service);
  if (addonServices) {
    price =
      parseFloat(price.toString()) +
      Utils.getAddonsPrice(addonServices?.filter((as) => as.selected));
  }
  let filteredAddons: Service[] = [];
  if (searchString) {
    filteredAddons = addonServices
      ? addonServices.filter((aa) => aa.name.toLowerCase().indexOf(searchString.toLowerCase()) >= 0)
      : [];
  } else {
    filteredAddons = addonServices ? addonServices : [];
  }
  const userSelectedAddons = addonServices?.filter((as) => as.selected);
  const onBack = () => {
    onBackClick && onBackClick();
  };
  const servicePrice = Utils.getPriceFromService(appointmentData?.service);

  return (
    <section className="select-addon-services">
      {userContext?.isLandscape && <BackNav onClick={onBack} />}
      <div className="title">
        <p>{t('Add-on services')}</p>
        <p>{t('Checkout any additional services for your pet')}</p>
      </div>
      <>
        <div className="select-addons-container">
          <div className="list">
            {filteredAddons?.map((addonService, index) => (
              <div className={`addon-item ${addonService.selected ? 'selected' : ''}`}>
                <div className="addon-details">
                  <p className="name" title={addonService.name}>
                    {addonService.name}
                  </p>
                  <p className="desc" title={addonService.description}>
                    {addonService.description}
                  </p>
                </div>
                <div className="selection">
                  <span className="amount">
                    +{businessCurrency(business,'USD')} {Utils.roundDecimal(addonService.price as number)}
                  </span>
                  <label
                    htmlFor={`option-check-${index}`}
                    className="check-container"
                    onClick={(e) => selectAddons(e, addonService)}
                  >
                    <input type="checkbox" checked={addonService.selected} />
                    <span className="checkmark"></span>
                  </label>
                </div>
              </div>
            ))}
          </div>
        </div>
        {showPriceBreakup && (
          <div className="price-breakup">
            <div className="main-line-item">
              <span className="line-item-title">{appointmentData?.service?.name}</span>
              <span className="line-item-value">{businessCurrency(business,'USD')} {Utils.roundDecimal(servicePrice)}</span>
            </div>
            {addonServices &&
              addonServices.map((addon, index) => {
                return addon.selected ? (
                  <div className="child-line-item" key={index + 'addons'}>
                    <span className="line-item-title">{addon.name}</span>
                    <span className="line-item-value">{businessCurrency(business,'USD')} {Utils.roundDecimal(addon.price)}</span>
                  </div>
                ) : (
                  <></>
                );
              })}

            <div className="main-line-item">
              <span className="line-item-title">{t('Sub total')}</span>
              <span className="line-item-value">{businessCurrency(business,'USD')} {Utils.roundDecimal(price)}</span>
            </div>
          </div>
        )}
      </>
      <div className="action">
        <div className="price-details">
          {userSelectedAddons && userSelectedAddons?.length > 0 && (
            <>
              <span className="total-amount">{businessCurrency(business,'USD')} {Utils.roundDecimal(price)}</span>
              <span className="link" onClick={() => setShowPriceBreakup(!showPriceBreakup)}>
                {!showPriceBreakup ? t('View') : t('Hide')} {t('price breakup')}
              </span>
            </>
          )}
        </div>
        <button className="petsked-button button-dark" onClick={() => onNext && onNext()}>
          {t('Continue')}
        </button>
      </div>
    </section>
  );
};
